import BadgerAccordion from "badger-accordion/dist/badger-accordion";

export default class Accordion {
    /**
     *
     * @param {object} options
     */
    constructor(options) {
        const _defaults = {
            //
            hiddenClass: "is-hidden",
            activeClass: "is-active",

            //ACCORDION
            accordion: ".js-accordion",
            accordionHeader: ".js-accordion-header",
            accordionPanel: ".js-accordion-panel",
            accordionPanelInner: ".js-accordion-panel-inner",

            //
            accordionClose: ".js-accordion-close",
        };

        this.defaults = Object.assign({}, _defaults, options);

        if (this.accordion.length > 0) {
            this.init();
            this.initAccordion();
        }
    }

    //region getters
    /**
     *
     * @returns {NodeListOf<Element>}
     */
    get accordion() {
        return document.querySelectorAll(this.defaults.accordion);
    }
    //endregion

    init() {
        //console.log("Accordion init()");
    }

    initAccordion() {
        const accordions = this.accordion;

        const accordionOptions = {
            headerClass: this.defaults.accordionHeader,
            panelClass: this.defaults.accordionPanel,
            panelInnerClass: this.defaults.accordionPanelInner,
            hiddenClass: this.defaults.hiddenClass,
            activeClass: this.defaults.activeClass,
            //opened on init
            //openHeadersOnLoad: [0],
        };

        accordions.forEach((accordion, index) => {
            const accordionInstance = new BadgerAccordion(
                accordion,
                accordionOptions,
            );

            const accordionClose = accordion.querySelectorAll(
                this.defaults.accordionClose,
            );

            accordionClose.forEach((element, index) => {
                element.addEventListener("click", (ev) => {
                    ev.preventDefault();
                    accordionInstance.close([index]);
                });
            });
        });
    }
}
